import { api } from './api';

const makeRoleHeaders = (userRoleUuid) => {
    if (!userRoleUuid) {
        throw new Error('Missing active user role UUID.');
    }

    return {
        'USER-ROLE': userRoleUuid
    };
};

export const getClinicalParameters = async ({ userRoleUuid }) =>
    api.get('/parameters', {
        headers: makeRoleHeaders(userRoleUuid)
    });

export const updateClinicalParameters = async ({ userRoleUuid, parameters }) =>
    api.post(
        '/parameters',
        { parameters },
        {
            headers: makeRoleHeaders(userRoleUuid)
        }
    );
